import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { servicesData } from '../mock';

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = servicesData.find(s => s.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Xidmət tapılmadı</h1>
          <Button onClick={() => navigate('/')}>Ana səhifəyə qayıt</Button>
        </div>
      </div>
    );
  }

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('#contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url(${service.heroImage})`
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <Button
            variant="ghost"
            className="text-white hover:text-white hover:bg-white/20 mb-8"
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="mr-2" size={20} />
            Geri
          </Button>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            {service.title}
          </h1>
          <p className="text-xl text-white/90 max-w-2xl">
            {service.description}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div
            className="prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: service.detailedContent }}
            style={{
              color: '#374151',
              lineHeight: '1.8'
            }}
          />

          {/* CTA Section */}
          <div className="mt-16 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8 md:p-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Bu xidmət haqqında daha ətraflı məlumat almaq istəyirsiniz?
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              Mütəxəssislərimiz sizə kömək etməyə hazırdır. Bizimlə əlaqə saxlayın.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white"
                onClick={scrollToContact}
              >
                <Mail className="mr-2" size={20} />
                Əlaqə formu
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => window.location.href = 'tel:+994502950494'}
              >
                <Phone className="mr-2" size={20} />
                +994502950494
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Digər Xidmətlərimiz
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {servicesData
              .filter(s => s.id !== service.id)
              .map(relatedService => (
                <div
                  key={relatedService.id}
                  className="bg-white rounded-xl p-6 hover:shadow-xl transition-all duration-300 cursor-pointer hover:-translate-y-2"
                  onClick={() => {
                    navigate(`/services/${relatedService.slug}`);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  <h4 className="text-lg font-bold text-gray-900 mb-2 hover:text-blue-600 transition-colors">
                    {relatedService.title}
                  </h4>
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {relatedService.description}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
